import { useTranslation } from 'next-i18next'
import { useLoginLink } from 'services/loginLink'

import { BUTTON_TYPES } from './types'
import { LinkButton } from './'

export function GetStartedButton({ type = BUTTON_TYPES.NORMAL }) {
    const { t } = useTranslation('common')
    const loginLink = useLoginLink()

    return (
        <LinkButton href={loginLink} type={type}>
            {t('menu.getStarted')}
        </LinkButton>
    )
}
